const groups = [
  {
    title: "栏目导航",
    links: [
      { href: "#ranking", label: "热门榜单" },
      { href: "#serial", label: "人气连载" },
      { href: "#featured", label: "霸榜作品" },
      { href: "#category", label: "漫画分类" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { href: "#faq", label: "常见问题" },
      { href: "#about", label: "关于我们" },
      { href: "#contact", label: "联系方式" },
      { href: "#home", label: "返回顶部" },
    ],
  },
  {
    title: "内容合作",
    links: [
      { href: "#contact", label: "作者投稿" },
      { href: "#contact", label: "版权合作" },
      { href: "#contact", label: "反馈邮箱" },
      { href: "#contact", label: "读者社群" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">番木瓜漫画</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/85">
              人气连载 + 追更进度条，热门榜单霸榜作品周更追踪。点开即知最新话进度，长期连载不怕断。
            </p>
          </div>

          {groups.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <h4 className="font-medium text-background-50">{g.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-background-100/85 transition-colors hover:text-accent-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-sm text-background-100/80">© 2026 番木瓜漫画 · 致力于每一部连载都不被错过</p>
          <div className="flex items-center gap-4">
            <a href="#home" aria-label="返回顶部" className="text-background-100/80 transition-colors hover:text-accent-300">
              <i className="ri-arrow-up-line"></i>
            </a>
            <span className="text-sm text-background-100/80">追更进度 · 实时同步</span>
          </div>
        </div>
      </div>
    </footer>
  );
}